export default __webpack_public_path__ + "images/spacing.688d9e4.svg";